import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, FormControl, FormArray, Validators, NgForm } from '@angular/forms';
import { AuthService } from '../../service/auth.service';
import { TokenService } from '../../service/token.service';
import { SpinnerService } from '../../service/spinner.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  loginFormErrors: any;
  submitted: Boolean = false;
  emailPattern = '^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$';

  constructor(
    private formBuilder: FormBuilder,
    private servicesComponent: AuthService,
    private router: Router,
    private tokenService: TokenService,
    private spinnerService: SpinnerService, private toastr: ToastsManager) {
  }

  login: any = { email: '', password: '' };

  ngOnInit() {
    this.loginForm = new FormGroup({
      'email': new FormControl(this.login.email, [
        Validators.required,
      ]),
      'password': new FormControl(this.login.password, [
        Validators.required
      ])
    });
  }

  logIn(loginForm) {
    this.submitted = false;
    if (loginForm.valid) {
      this.spinnerService.displayLoader(true);
      this.servicesComponent.login(this.login)
        .then(result => {
          this.spinnerService.displayLoader(false);
          if (result.error) {
            this.toastr.error(result.message);
            return;
          }
          this.tokenService.setToken(result.access_token);
          this.tokenService.setRefToken(result.refresh_token);
          this.tokenService.setRoleToken(result.role);
          this.tokenService.setPersmission(result.usersPermission);
          this.router.navigate(['./welcome']);
        })
        .catch(error => {
          this.spinnerService.displayLoader(false);
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
          console.log(error);
        });
    } else {
      this.submitted = true;
    }
  }

}




// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/code/kapil/DubairentV3/cpapi/CPDubairentApp/CPDubairentApp/src/app/auth/login/login.component.ts